import './styles.scss'
import React, { useEffect, createRef } from 'react'

const OptionsTooltip = ({ modalPortal, selectorCoords, options, position, toggle }) => {
  const tooltipRef = createRef(null)
  // const [arrowStyle, setArrowStyle] = React.useState({
  //   top: ['top', 'right', 'left'].includes(position) ? null : '-10px',
  //   right: ['top', 'right', 'bottom'].includes(position) ? null : '-10px',
  //   bottom: ['right', 'bottom', 'left'].includes(position) ? null : '-10px',
  //   left: ['top', 'bottom', 'left'].includes(position) ? null : '-10px',
  //   borderTop: `10px solid ${['bottom', 'left'].includes(position) ? '#ffffff' : 'transparent'}`,
  //   borderRight: `10px solid ${['top', 'left'].includes(position) ? '#ffffff' : 'transparent'}`,
  //   borderBottom: `10px solid ${['top', 'right'].includes(position) ? '#ffffff' : 'transparent'}`,
  //   borderLeft: `10px solid ${['right', 'bottom'].includes(position) ? '#ffffff' : 'transparent'}`
  // });

  useEffect(() => {
    const toogleModalPortal = (event) => {
      if (event.target.style.display === 'flex') {
        event.target.style.display = 'none'
        toggle()
      } else {
        event.target.style.display = 'flex'
      }
    }
    modalPortal && modalPortal.addEventListener("click", toogleModalPortal) 
    return () => modalPortal && modalPortal.removeEventListener("click", toogleModalPortal)
  }, [modalPortal, toggle])

  useEffect(() => {
    if (tooltipRef && tooltipRef.current) {
      const tooltip = tooltipRef.current
      const tooltipCoordinates = tooltip.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth

      const tooltipHeight = tooltipCoordinates.height
      const tooltipWidth = tooltipCoordinates.width

      let topPosition = position === "top" ? selectorCoords.bottom - tooltipHeight : selectorCoords.bottom
      topPosition = Math.min(Math.max(topPosition, 0), viewportHeight - tooltipHeight - 10)

      let leftPosition = position === "left" ? selectorCoords.right - tooltipWidth: selectorCoords.right
      leftPosition = Math.min(Math.max(leftPosition, 0), viewportWidth - tooltipWidth - 10)

      tooltip.style.top = `${topPosition}px`
      tooltip.style.left = `${leftPosition}px`
    }
  }, [tooltipRef, selectorCoords, position])


  if (options.length) {
    return (
      <div ref={tooltipRef} className='options-tooltip'>
        <div className='options-tooltip__content'>
          <ul>
            {options.map((option, index) => {
              return (
                <li
                  key={index}
                  onClick={option.onClick}
                  style={{ color: option.fontColor ? option.fontColor : null }}
                >
                  {option.imageIcon && <img src={option.imageIcon} alt={option.name} />}
                  {option.icon && <i className={option.icon}></i>}
                  <span>{option.name}</span>
                </li>
              )
            }
            )}
          </ul>
        </div>
        {/* <div className='options-tooltip__arrow' style={arrowStyle}></div> */}
      </div>
    )
  }

  return null
}

export default OptionsTooltip
